var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "chat clearfix",
    class: {
      kioskStyle: _vm.$route.name.includes('kiosk')
    }
  }, [_c('div', {
    staticClass: "left chatList",
    class: {
      kioskStyle: _vm.$route.name.includes('kiosk')
    }
  }, [_c('div', {
    staticClass: "channel"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('chatM.publicRoom')) + " ")]), _c('ul', [_c('li', {
    class: {
      active: _vm.activeChat.rtilCode == _vm.chatPartyCode
    },
    on: {
      "click": function ($event) {
        return _vm.changeChat();
      }
    }
  }, [_c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.$t('chatM.groupChat')))]), _vm.activeChat.rtilCode != _vm.chatPartyCode && _vm.isReadInfo[_vm.chatPartyCode] && _vm.isReadInfo[_vm.chatPartyCode].unRead ? _c('i', {
    staticClass: "unread"
  }) : _vm._e()])])]), _c('div', {
    staticClass: "channel private"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('chatM.personalRoom')) + " ")]), _c('ul', {
    staticClass: "scrollbar"
  }, _vm._l(_vm.chatList, function (val, key) {
    return _c('li', {
      key: key,
      class: {
        active: _vm.activeChat.rtilCode == val.rtilCode
      },
      on: {
        "click": function ($event) {
          return _vm.changeChat(val);
        }
      }
    }, [_c('span', {
      staticClass: "content",
      attrs: {
        "rtilCode": val.rtilCode
      }
    }, [_vm._v(_vm._s(_vm.nickNameInfo[val.rtilCode]) + " "), _vm.userInfo.managerRtils.includes(_vm.userInfo.rtilCode) && _vm.tagNameInfo[val.rtilCode] ? _c('span', [_vm._v(_vm._s(` / ${_vm.tagNameInfo[val.rtilCode]}`))]) : _vm._e()]), _vm.isReadInfo[val.rtilCode] && _vm.isReadInfo[val.rtilCode].unRead && _vm.activeChat.rtilCode != val.rtilCode ? _c('i', {
      staticClass: "unread"
    }) : _vm._e()]);
  }), 0), !_vm.lockPrivate || _vm.userInfo.managerRtils.includes(_vm.userInfo.rtilCode) ? _c('div', {
    staticClass: "addChat",
    class: {
      active: _vm.memberBtn
    },
    on: {
      "click": _vm.changeMember
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(_vm._s(_vm.$t('chatM.newMessage')) + " ")]) : _vm._e(), _vm.$route.path.indexOf('/control') > -1 ? _c('div', {
    staticClass: "lockChat"
  }, [_c('el-popover', {
    attrs: {
      "placement": "top",
      "width": "280",
      "popper-class": "lockChatSetting",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "lock"
  }, [_vm._v(" " + _vm._s(_vm.$t('chatM.lockPub')) + " "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('chatM.tooPub'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "el-icon-info"
  })]), _c('el-switch', {
    staticClass: "right",
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#9B9B9B"
    },
    on: {
      "change": function ($event) {
        return _vm.changeLock('public');
      }
    },
    model: {
      value: _vm.lockPublic,
      callback: function ($$v) {
        _vm.lockPublic = $$v;
      },
      expression: "lockPublic"
    }
  })], 1), _c('div', {
    staticClass: "lock"
  }, [_vm._v(" " + _vm._s(_vm.$t('chatM.lockPri')) + " "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('chatM.toopPri'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "el-icon-info"
  })]), _c('el-switch', {
    staticClass: "right",
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#9B9B9B"
    },
    on: {
      "change": function ($event) {
        return _vm.changeLock('private');
      }
    },
    model: {
      value: _vm.lockPrivate,
      callback: function ($$v) {
        _vm.lockPrivate = $$v;
      },
      expression: "lockPrivate"
    }
  })], 1), _c('p', {
    staticClass: "gray"
  }, [_vm._v(_vm._s(_vm.$t('chatM.chatNote')))])]), _c('span', {
    staticClass: "settingBtn",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v(_vm._s(_vm.$t('chatM.chatSet')))])])], 1) : _vm._e()])]), !_vm.memberBtn ? _c('div', {
    staticClass: "left messageList",
    class: {
      kioskStyle: _vm.$route.name.includes('kiosk')
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "chatTitle"
  }, [_vm._v(_vm._s(_vm.activeChat.rtilCode == _vm.chatPartyCode ? _vm.$t('chatM.groupChat') : _vm.nickNameInfo[_vm.activeChat.rtilCode]) + " "), _vm.userInfo.managerRtils.includes(_vm.userInfo.rtilCode) && _vm.tagNameInfo[_vm.activeChat.rtilCode] ? _c('span', [_vm._v(_vm._s(` / ${_vm.tagNameInfo[_vm.activeChat.rtilCode]}`))]) : _vm._e()]), _c('i', [_vm._v("(" + _vm._s(_vm.messageInfo[_vm.activeChat.rtilCode] ? _vm.messageInfo[_vm.activeChat.rtilCode].length : 0) + ")")])]), _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.scroll,
      expression: "scroll"
    }],
    ref: "chat",
    staticClass: "chatMessage scrollbar"
  }, [_vm.loadingMessage[_vm.activeChat.rtilCode] && (!_vm.messageInfo[_vm.activeChat.rtilCode] || !_vm.messageInfo[_vm.activeChat.rtilCode].length) ? _c('i', {
    staticClass: "el-icon-loading loading"
  }) : _vm._e(), _c('ul', {}, _vm._l(_vm.messageInfo[_vm.activeChat.rtilCode], function (val, key) {
    return _c('li', {
      key: key
    }, [val.showDate ? _c('el-divider', [_vm._v(_vm._s(_vm._f("FormatTime")(val.timestamp, 'MM/DD/YYYY')))]) : _vm._e(), _c('div', {
      staticClass: "info clearfix",
      class: {
        green: _vm.roleSign(val.source)
      }
    }, [_c('span', {
      staticClass: "name left"
    }, [_vm._v(_vm._s(_vm.nickNameInfo[val.source]) + " "), _vm.userInfo.managerRtils.includes(_vm.userInfo.rtilCode) && _vm.tagNameInfo[val.source] ? _c('span', [_vm._v(_vm._s(` / ${_vm.tagNameInfo[val.source]}`))]) : _vm._e()]), _vm.userInfo.rtilCode == val.source ? _c('span', {
      staticClass: "left"
    }, [_vm._v("(me)")]) : _vm._e(), _vm.roleSign(val.source) ? _c('span', {
      staticClass: "left greenBg"
    }, [_vm._v(_vm._s(_vm.roleSign(val.source)))]) : _vm._e(), _c('span', {
      staticClass: "left time"
    }, [_vm._v(_vm._s(_vm._f("FormatTime")(val.timestamp, 'h:mm A')))])]), _c('div', {
      staticClass: "message"
    }, [_vm.changeToLink(val.message).frontText !== _vm.changeToLink(val.message).link && _vm.changeToLink(val.message).frontText ? _c('span', [_vm._v(_vm._s(_vm.changeToLink(val.message).frontText))]) : _vm._e(), _c('div', {
      staticClass: "contextmenuOperate"
    }, [_c('div', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: _vm.copyLink(val),
        expression: "copyLink(val)",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: _vm.onCopy,
        expression: "onCopy",
        arg: "success"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:error",
        value: _vm.onError,
        expression: "onError",
        arg: "error"
      }]
    }, [_vm._v(" Copy link ")]), _c('div', {
      on: {
        "click": function ($event) {
          return _vm.openLink(val);
        }
      }
    }, [_vm._v(" Open link ")])]), _vm.changeToLink(val.message).link ? _c('a', {
      attrs: {
        "href": _vm.changeToLink(val.message).link,
        "target": "_blank"
      },
      on: {
        "contextmenu": function ($event) {
          $event.preventDefault();
          return _vm.myContextmenu($event, val, key);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.changeToLink(val.message).link) + " ")]) : _vm._e(), _vm.changeToLink(val.message).backText ? _c('span', [_vm._v(" " + _vm._s(_vm.changeToLink(val.message).backText) + " ")]) : _vm._e()])], 1);
  }), 0)]), !_vm.disabledChat ? _c('div', {
    staticClass: "sendBox",
    class: {
      green: _vm.message,
      kioskStyle: _vm.$route.name.includes('kiosk')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 1,
        maxRows: 8
      },
      "placeholder": _vm.activeChat.rtilCode == _vm.chatPartyCode ? _vm.$t('chatM.sendEveryone') : _vm.$t('chatM.message') + ` ${_vm.nickNameInfo[_vm.activeChat.rtilCode] || ''}`,
      "maxlength": 2048
    },
    on: {
      "input": function ($event) {
        return _vm.inputMessage();
      }
    },
    nativeOn: {
      "keydown": function ($event) {
        return _vm.handleKeyCode($event);
      }
    },
    model: {
      value: _vm.message,
      callback: function ($$v) {
        _vm.message = $$v;
      },
      expression: "message"
    }
  }), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('chatM.sendM'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "el-icon-position",
    on: {
      "click": _vm.sendMessage
    }
  })])], 1) : _vm._e(), _vm.disabledChat ? _c('div', {
    staticClass: "sendBox"
  }, [_c('span', {
    staticClass: "grays"
  }, [_vm._v("Not available")])]) : _vm._e()]) : _vm._e(), _vm.memberBtn ? _c('div', {
    staticClass: "left memberList",
    class: {
      kioskStyle: _vm.$route.name.includes('kiosk')
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('chatM.searchPart')
    },
    on: {
      "input": _vm.search
    },
    model: {
      value: _vm.searchMember,
      callback: function ($$v) {
        _vm.searchMember = $$v;
      },
      expression: "searchMember"
    }
  }), _c('i', {
    staticClass: "el-icon-search",
    on: {
      "click": _vm.search
    }
  })], 1)]) : _vm._e(), _vm.memberBtn ? _c('ul', {
    staticClass: "scrollbar chatMemberList left",
    class: {
      kioskStyle: _vm.$route.name.includes('kiosk')
    }
  }, _vm._l(_vm.allChatList, function (rtilCode) {
    return _c('li', {
      key: rtilCode,
      class: {
        green: _vm.roleSign(rtilCode)
      },
      on: {
        "click": function ($event) {
          return _vm.selectMember(rtilCode);
        }
      }
    }, [!_vm.filterHide[rtilCode] && _vm.nickNameInfo[rtilCode] ? _c('div', {
      staticClass: "clearfix box"
    }, [_c('p', {
      staticClass: "left"
    }, [_c('span', [_vm._v(" " + _vm._s(_vm.nickNameInfo[rtilCode]) + " "), _vm.userInfo.managerRtils.includes(_vm.userInfo.rtilCode) && _vm.tagNameInfo[rtilCode] ? _c('span', [_vm._v(" " + _vm._s(` / ${_vm.tagNameInfo[rtilCode]}`) + " ")]) : _vm._e()]), _vm.userInfo.rtilCode == rtilCode ? _c('span', [_vm._v("(me)")]) : _vm._e(), _vm.roleSign(rtilCode) ? _c('span', {
      staticClass: "greenBg"
    }, [_vm._v(_vm._s(_vm.roleSign(rtilCode)))]) : _vm._e()]), _c('p', {
      staticClass: "right organization"
    }, [_vm._v(_vm._s(_vm.organizationInfo[rtilCode]))])]) : _vm._e()]);
  }), 0) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };